import styled from "styled-components";
import React from "react";
import {IdeaPortfolioUpdateOutcome} from "./IdeaPortfolioUpdateOutcome";
import partialIcon from "../../../../images/icon-alert-circle.svg";
import warningIcon from "../../../../images/icon-confirmation-failed.svg";

const Container = styled.div`
    display: flex;
    flex-shrink: 0;
`;

const WarningIcon = styled.img`
    width: 29px;
    height: 29px;
    margin-right: 33px;
    margin-left: 6px;
    flex-shrink: 0;
`;

const OutcomesContainer = styled.div`
    display: flex;
    flex-direction: column;
    flex-shrink: 0;
`;

const Spacer = styled.div`
    margin-top: 12px;
`;

export const FailedOutcomes = ({failed, className, severity}) => {
    if (!failed || failed.length === 0) return null;

    return <Container className={className}>
            <WarningIcon src={severity === "partial" ? partialIcon : warningIcon}/>
            <OutcomesContainer>
                {
                    failed.map((outcome, index) => {
                        if (index === 0) {
                            return <IdeaPortfolioUpdateOutcome key={outcome.portfolioId}
                                                               outcome={outcome}
                                                               severity={severity}/>;
                        }

                        return <React.Fragment key={outcome.portfolioId}>
                            <Spacer/>
                            <IdeaPortfolioUpdateOutcome outcome={outcome}
                                                        severity={severity}/>
                        </React.Fragment>
                    })
                }
            </OutcomesContainer>
        </Container>;
};
